import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=d6223b58&scoped=true"
import script from "./addBanner.vue?vue&type=script&lang=js"
export * from "./addBanner.vue?vue&type=script&lang=js"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=d6223b58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6223b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6223b58')) {
      api.createRecord('d6223b58', component.options)
    } else {
      api.reload('d6223b58', component.options)
    }
    module.hot.accept("./addBanner.vue?vue&type=template&id=d6223b58&scoped=true", function () {
      api.rerender('d6223b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/addBanner.vue"
export default component.exports